<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Pays :</label>
        </div>
        <div v-if="!libellesPaysLoading" class="col">
          <Dropdown
            v-model="pays"
            :options="paysLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
        <div v-else class="col">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Province :</label>
        </div>
        <div v-if="!libellesProvinceLoading" class="col">
          <Dropdown
            v-model="province"
            :options="provinceLibelles"
            :showClear="true"
            :filter="true"
            optionValue="cle"
            optionLabel="description"
            scrollHeight="205px"/>
        </div>
        <div v-else class="col">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Ville :</label>
        </div>
        <div class="col">
          <InputText id="ville" type="text" v-model="ville" />
        </div>
      </div>
    </div>
    <div class="col border-white">
      <div class="row">
        <div class="col">
          <h2>Autres</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button @click="redirectionClassementPays"> Pays </Button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button @click="redirectionClassementProvince"> Province </Button>
        </div>
      </div>
    </div>
  </div>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="redirectionAjouterVille"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  emits: ['rechercher'],
  data() {
    return {
      ville: null,
      pays: null,
      province: null,
      provinceLibelles: [],
      paysLibelles: [],
      libellesPaysLoading: false,
      libellesProvinceLoading: false,
    }
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.libellesPaysLoading = true;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Pays').then((res) => {
      this.paysLibelles = res.data;
      this.paysLibelles.sort(function (a, b) {
        if (a.texte < b.texte) {
          return -1;
        }
        if (a.texte > b.texte) {
          return 1;
        }
        return 0;
      });
      this.libellesPaysLoading = false;
    });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    redirectionAjouterVille() {
      this.$router.push({name: 'ajouterVillePilotage'});
    },
    redirectionClassementPays() {
      this.$router.push({name: 'classementPaysPilotage'});
    },
    redirectionClassementProvince() {
      this.$router.push({name: 'classementProvincesPilotage'});
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    rechercher() {

      if(this.pays == null){
        this.pays = 702;
      }
      let libelleRecherche = {};
      libelleRecherche.valeur = this.pays;
      libelleRecherche.enfant = {};
      libelleRecherche.enfant.valeur = this.province;
      libelleRecherche.enfant.enfant = {};
      libelleRecherche.enfant.enfant.texte = this.ville;
      libelleRecherche.enfant.enfant.code = 'Ville';

      this.$emit('rechercher', libelleRecherche);
    }
  },
  watch: {
    pays: function (val) {
      if (val !== null && val !== undefined) {
        this.libellesProvinceLoading = true;
        let libelleRecherche = {};
        libelleRecherche.valeur = this.pays;
        libelleRecherche.enfant = {};
        libelleRecherche.enfant.code = 'Province';
        
        this.provinceLibelles = [];
        this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
          res.data.libelles.forEach((currentPays) => {
            currentPays.tableValeur.libelles.forEach((currentProvince) => {
              let currentProvinceComplete = currentProvince;
              currentProvinceComplete.clePays = currentPays.tableValeur.cle;
              currentProvinceComplete.pays = currentPays.tableValeur.description;
              this.provinceLibelles.push(currentProvinceComplete)
            })
          })
          this.provinceLibelles.sort(function (a, b) {
            if (a.description < b.description) {
              return -1;
            }
            if (a.description > b.description) {
              return 1;
            }
            return 0;
          });
          this.libellesProvinceLoading = false;
          this.province = null;
        });
      } else {
        this.province = null;
        this.provinceLibelles = [];
      }
    },
  }
}
</script>
